import { useState } from 'react'
import { ElementForm } from '../../models/element.model'
import ElementCreateForm from '../ElementCreateForm'


export default function ElementCreate({ setBlockScreen }: any) {

  const [elementForm, setElementForm] = useState<ElementForm>({
    name: '',
    code: '',
    site: '',
    element_type: '',
    description: '',
    created_date: ''
  })

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setElementForm({
      ...elementForm,
      [event.target.name]: event.target.value
    });
  }

  const handleSelection = (key: string, value: string): void => {
    setElementForm({
      ...elementForm,
      [key]: value
    });
  }

  return (
    <ElementCreateForm
      setBlockScreen={setBlockScreen}
      action='create'
      elementForm={elementForm}
      handleChange={handleChange}
      handleSelection={handleSelection}
    /> 
  )
}